import axios from 'axios';
import React, { useState, useRef, useEffect } from 'react';
import { BACKEND_URL } from '../config';

const AZPAY = ({item, options,onSuccess}) => {
    const [passwordType, setPasswordType] = useState('password')
    const [password, setPassword] = useState('')
    const [isLoaded, setIsLoaded] = useState(false)
    const [availableAmount, setAvailableAmount] = useState(false)
    const [disabled, setdDisabled] = useState(false)
    const [amountToPay, setAmountToPay] = useState(0)
    const [amountText, setAmountText] = useState('')
    const [errorPasswordConfirmation, setErrorPasswordConfirmation] = useState('')
    const btnClas = "px-3 py-1 rounded my-4 text-center w-3/4 md:w-1/2 mx-auto block "
    const flag = useRef(false);
    
    const togglePassword = () => {
        if(passwordType === 'password')
            setPasswordType('text')
        else
            setPasswordType('password')
    }

    const confirm = () => {
        setdDisabled(true)
        if(password)
        {
            setErrorPasswordConfirmation("")
            axios.post(`${BACKEND_URL}payment/azpay/confirm`, {
                lang: 'fr',
                password: password,
                amount: amountToPay,
                customer_number: options['customer']['id'],
                seller_number: options['seller_number']
            })
            .then(response => {
                if(response.data.type === 'success')
                {
                    let tab = options.success_url.split('?');
                    let success_url= tab[0];
                    let query= tab[1] ?? '';
                    if(query.length >0) query +='&';
                    query += 'provider=1&paymentId=' + response.data.paymentId +'&id_currency='+ options['id_currency'];
                     onSuccess(1,response.data.paymentId,options['id_currency'])
                    // window.location = success_url +'?' + query;
                }else
                {
                    setErrorPasswordConfirmation(response.data.message)
                }
            })
        }
        else
        {
            setErrorPasswordConfirmation("Veuillez entrer votre mot de passe")
        }
    }

    useEffect(() => {
        if(flag.current === false)
        {
            axios.post(`${BACKEND_URL}payment/azpay/wallet`, {
                id_currency: options['id_currency'],
                amount:options['amount'],
                customer_number: options['customer']['id'],
            })
            .then(response => {
                if(response.data.success)
                {
                    setAvailableAmount(true);
                    setAmountToPay(response.data.amount_usd)
                    setAmountText(response.data.amount_to_pay)
                }
                else{
                    setAvailableAmount(false);
                }
                setIsLoaded(true);
            })
        }
        return () => flag.current = true;
    }, []);


    return (
        isLoaded &&
        <>
            <h5 className='mb-4 font-bold bg-gray-400 px-3 py-2 text-center'>Paiement avec AZ PAY</h5>
            {
                availableAmount 
                ?
                    <div className="max-w-md mx-auto bg-white rounded-xl shadow-md overflow-hidden md:max-w-2xl p-6 border border-blue-100 bg-gradient-to-br from-white to-blue-50">
                        <div className="mb-6">
                            <h2 className="text-2xl font-bold text-white mb-2 bg-blue-700 py-2 px-4 rounded-lg shadow-md inline-block">Confirmation de paiement</h2>
                            <div className="h-1 w-20 bg-blue-500 rounded"></div>
                        </div>
                        
                        <div className="space-y-6">
                            <div className="space-y-4">
                            <label className="text-gray-700 text-lg font-medium block" htmlFor="azpayTransaction_password_confirmation">
                                Entrez votre mot de passe pour confirmer le paiement de
                                <span className="font-bold text-gray-900 ml-2">{amountText}</span>
                                <span className="text-red-500">*</span>
                            </label>
                            
                            <div className="relative">
                                <input 
                                type={passwordType} 
                                id="azpayTransaction_password_confirmation" 
                                className="border border-gray-300 rounded-lg h-12 px-4 w-full bg-transparent outline-none text-base focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all" 
                                onChange={e => {
                                    setPassword(e.target.value);
                                }} 
                                placeholder="••••••••"
                                />
                                
                                <button 
                                type="button"
                                className="absolute right-3 top-3 text-gray-500 hover:text-gray-700 focus:outline-none transition-colors" 
                                onClick={togglePassword}
                                >
                                {passwordType === 'password' ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                                    </svg>
                                )}
                                </button>
                            </div>
                            
                            {errorPasswordConfirmation && (
                                <p className="text-red-500 text-sm italic flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                                {errorPasswordConfirmation}
                                </p>
                            )}
                            </div>
                            
                            <div className="pt-2">
                            <button 
                                onClick={confirm} 
                                className={`w-full rounded-lg h-12 font-medium text-base transition-all duration-200 ${
                                disabled 
                                    ? 'bg-gray-200 text-gray-500 cursor-not-allowed' 
                                    : 'bg-blue-600 hover:bg-blue-700 text-white shadow-md hover:shadow-lg'
                                }`} 
                                type="button" 
                                id="azpayTransactionConfirm"
                            >
                                Confirmer le paiement
                            </button>
                            </div>
                            
                            <div className="text-center text-sm text-blue-600 mt-4 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                            Transaction sécurisée par AZPay
                            </div>
                        </div>
                    </div>
                :
                    <div className='text-red-500 flex flex-col items-center'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 md:w-16 md:h-16">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                        </svg>
                        <p className='mt-4 italic text-lg'>Oops! votre solde est insufissant.</p>
                    </div>
            }
        </>
    );
};

export default AZPAY;